"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasEliminations = void 0;
function hasEliminations(game) {
    var withEliminations = game;
    return typeof withEliminations.isEliminated === 'function';
}
exports.hasEliminations = hasEliminations;
